<template>
  <el-card>
    <div
        slot="header"
        class="clearfix"
    >
      <span>Leltáreltérés</span>
    </div>
    <div v-loading="loading" class="filter-container">
      <el-form
          label-position="top"
      >
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item
                label="Raktár"
            >
              <el-select
                  v-model="storage"
                  value-key="id"
                  style="width: 100%;"
                  filterable
              >
                <el-option
                    v-for="s in storages"
                    :key="s.id"
                    :label="s.name"
                    :value="s"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
                label="Időszak"
            >
              <el-date-picker
                  v-model="dateRange"
                  style="width: 100%;"
                  type="daterange"
                  :clearable="false"
                  format="yyyy. MM. dd."
                  value-format="yyyy-MM-dd"
                  :picker-options="dateRangeOptions"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
                label="Termék kategória"
            >
              <el-select
                  clearable
                  v-model="productCategory"
                  value-key="id"
                  style="width: 100%;"
                  filterable
              >
                <el-option
                    v-for="p in productCategories"
                    :key="p.id"
                    :label="p.name"
                    :value="p"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
                label="Termék"
            >
              <el-select
                  v-model="product"
                  filterable
                  remote
                  clearable
                  :remote-method="searchProduct"
                  :loading="productLoading"
                  placeholder="Gépelj a kereséshez..."
                  style="width: 100%;"
                  value-key="id"
              >
                <el-option
                    v-for="p in products"
                    :key="p.id"
                    :value="p"
                    :label="p.name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
                label="Rögzítő"
            >
              <el-select
                  v-model="user"
                  filterable
                  clearable
                  style="width: 100%;"
                  value-key="id"

              >
                <el-option
                    v-for="user in users"
                    :key="user.id"
                    :value="user"
                    :label="user.full_name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6" style="display: flex;
    align-items: center;
    height: 80px;">
            <el-checkbox-group v-model="types">
              <el-checkbox label="plus" value="plus">Leltárhiány</el-checkbox>
              <el-checkbox label="minus" value="minus">Leltártöbblet</el-checkbox>
            </el-checkbox-group>
          </el-col>
        </el-row>
      </el-form>
      <div style="text-align: center;">
        <el-button
            :disabled="isDisabled"
            :loading="listLoading"
            icon="el-icon-tickets"
            @click="listStockDifference"
        >
          Listázás
        </el-button>
        <el-button
            :disabled="isDisabled"
            :loading="downloadLoading"
            icon="el-icon-download"
            @click="excelExport"
        >
          Letöltés
        </el-button>
        <el-button
            :disabled="isDisabled"
            :loading="printLoading"
            icon="el-icon-printer"
            @click="print"
        >
          Nyomtatás
        </el-button>
      </div>
    </div>
    <stock-difference-list :stock-difference="stockDifference" style="margin-top: 30px"/>
  </el-card>
</template>

<script>
  import StockDifferenceList from '../../components/reports/stockDifference/List';
  import moment from 'moment';
  import { saveAs } from 'file-saver';

  export default {
    components: {
      StockDifferenceList,
    },
    data() {
      return {
        stockDifference: [],
        loading: false,
        downloadLoading: false,
        printLoading: false,
        filterConfig: null,
        storage: null,
        dateRange: [moment().startOf('year').toDate(), moment().toDate()],
        productLoading: false,
        product: null,
        products: [],
        productCategories: [],
        productCategory: null,
        user: null,
        users: [],
        types: ['plus', 'minus'],
        dateRangeOptions: {
          firstDayOfWeek: 1,
          shortcuts: [{
            text: 'Aktuális hét',
            onClick(picker) {
              const start = moment().weekday(1).toDate();
              const end = moment().weekday(7).toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Előző hét',
            onClick(picker) {
              const start = moment().subtract({weeks: 1}).weekday(1).toDate();
              const end = moment().subtract({weeks: 1}).weekday(7).toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Aktuális hónap',
            onClick(picker) {
              const start = moment().startOf('month').toDate();
              const end = moment().endOf('month').toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Előző hónap',
            onClick(picker) {
              const start = moment().subtract({months: 1}).startOf('month').toDate();
              const end = moment().subtract({months: 1}).endOf('month').toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Előző 3 hónap',
            onClick(picker) {
              const start = moment().subtract({months: 3}).startOf('month').toDate();
              const end = moment().subtract({months: 1}).endOf('month').toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Aktuális év',
            onClick(picker) {
              const start = moment().startOf('year').toDate();
              const end = moment().endOf('year').toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Előző év',
            onClick(picker) {
              const start = moment().subtract({years: 1}).startOf('year').toDate();
              const end = moment().subtract({years: 1}).endOf('year').toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'YTD',
            onClick(picker) {
              const start = moment().startOf('year').toDate();
              const end = moment().toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'MTD',
            onClick(picker) {
              const start = moment().startOf('month').toDate();
              const end = moment().toDate();
              picker.$emit('pick', [start, end]);
            }
          }]
        },
      };
    },
    computed: {
      storages() {
        return this.$store.getters['storage/storages'];
      },
      isDisabled() {
        return !this.storage || !this.dateRange;
      },
      listLoading() {
        return this.$store.getters['productHistory/loading'];
      },
    },
    async mounted() {
      this.loading = true;
      await this.setConfig();
      this.loading = false;
    },
    methods: {
      async setConfig() {
        if (!this.storages.length) {
          await this.$store.dispatch('storage/fetchAll');
        }

        this.storage = this.storages.find(s => s.type === 'own');


        if (!this.productCategories.length) {
          await this.$store.dispatch('productCategory/fetchAll');
          this.productCategories = this.$store.getters['productCategory/productCategories'];
        }

        if (!this.users.length) {
          this.users = await axios.get('api/users');
        }
      },
      async searchProduct(query) {
        if (query !== '') {
          this.productLoading = true;
          this.products = await this.$store.dispatch('product/search', '?name=' + query);
          this.productLoading = false;
        }
      },
      async listStockDifference() {
        let query = '?';

        query += 'storage_id=' + this.storage.id;
        query += '&from=' + moment(this.dateRange[0]).startOf('day').format('YYYY-MM-DD HH:mm')
        query += '&to=' + moment(this.dateRange[1]).endOf('day').format('YYYY-MM-DD HH:mm')

        if (this.productCategory) {
          query += '&product_category_id=' + this.productCategory.id;
        }

        if (this.product) {
          query += '&product_id=' + this.product.id;
        }

        if (this.user) {
          query += '&user_id=' + this.user.id;
        }

        query += '&types=' + this.types.join();

        this.stockDifference = await axios.get('/api/reports/stock-difference' + query);
      },
      async excelExport() {
        this.downloadLoading = true;
        const excel = await axios({
          url: 'api/reports/stock-difference/download',
          method: 'POST',
          responseType: 'blob',
          data: {
            product_id: this.product ? this.product.id : null,
            product_category_id: this.productCategory ? this.productCategory.id : null,
            user_id: this.user ? this.user.id : null,
            storage_id: this.storage.id,
            types: this.types.join(),
            from: moment(this.dateRange[0]).startOf('day').format('YYYY-MM-DD HH:mm'),
            to: moment(this.dateRange[1]).endOf('day').format('YYYY-MM-DD HH:mm'),

          },
        });
        this.downloadLoading = false;
        saveAs(excel, 'stock-difference.xlsx');
      },
      async print() {
        this.printLoading = true;
        const response = await axios.post('api/reports/stock-difference/print', {
          product_id: this.product ? this.product.id : null,
          product_category_id: this.productCategory ? this.productCategory.id : null,
          user_id: this.user ? this.user.id : null,
          storage_id: this.storage.id,
          types: this.types.join(),
          from: moment(this.dateRange[0]).startOf('day').format('YYYY-MM-DD HH:mm'),
          to: moment(this.dateRange[1]).endOf('day').format('YYYY-MM-DD HH:mm'),
        }, {
          responseType: 'arraybuffer',
          headers: {
            'Accept': 'application/pdf'
          },
        });
        this.printLoading = false;

        const newBlob = new Blob([response], {type: 'application/pdf'});
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob);
          return;
        }

        const data = window.URL.createObjectURL(newBlob);
        window.open(data);
      },
    }
  };
</script>

<style lang="scss">
  .filter-container {
    padding: 20px;
    margin: -20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #EBEEF5;
  }

  .el-picker-panel [slot=sidebar], .el-picker-panel__sidebar {
    width: 150px;
  }

  .el-picker-panel [slot=sidebar] + .el-picker-panel__body, .el-picker-panel__sidebar + .el-picker-panel__body {
    margin-left: 150px;
  }
</style>
